import React, { Component } from 'react';
import {isEmptyVariable,isEmptyArray} from '../Global/commonFunctions';
import {Dropdown} from 'react-bootstrap';

class RegularDropDown extends Component {
    constructor(props) {
        super(props);
        this.state= {
            refresh:false
        }

        this.dropdownRef = React.createRef();
    }

    componentDidMount(){
        if(this.props.isFocusRequired && !this.state.refresh){
            this.setState({
                refresh:!this.state.refresh
            })
        }
    }

    componentDidUpdate(){
        //just rerendering so that first dropdown gets the focus
        if(this.props.isFocusRequired && this.state.refresh){
            this.setState({
                refresh:!this.state.refresh
            },()=>{
                this.dropdownRef.current.focus();
            })
        }
    }

    dropDownItemClick = (item,e) => {
        e.stopPropagation();
        if(isEmptyVariable(this.props.udf)){
            this.props.onDropDownItemClick(item);
        }else{
            this.props.onDropDownItemClick(item,this.props.udf);
        }
        
    }

    render(){
        const isSelected = this.props.placeholder !== this.props.defaultPlaceholderDropDown;
        return(
            <div className="regular-dropdown-layout" style={{position:'relative', marginTop:this.props.mTop??0}}>
            <Dropdown>
                <Dropdown.Toggle id="dropdown-basic" ref={this.dropdownRef} disabled={this.props.disabled?true:false}
                style={{cursor:this.props.disabled?'not-allowed':'pointer'}}>
                    {
                        this.props.placeholder === this.props.defaultPlaceholderDropDown &&
                        <p className="placeholder-text default-val">{this.props.placeholder}</p>
                    }
                    {
                        this.props.placeholder !== this.props.defaultPlaceholderDropDown &&
                        <p className="placeholder-text" style={{overflow:'hidden'}}>{this.props.placeholder}</p>
                    }
                    {
                        !isSelected && <span className="material-icons" style={{fontSize:24,margin:0}}>expand_more</span>
                    }
                </Dropdown.Toggle>
                <Dropdown.Menu>
                {
                    !isEmptyVariable(this.props.dropdownArr) &&
                    this.props.dropdownArr.map((item)=>{
                        return <Dropdown.Item onClick={this.dropDownItemClick.bind(this,item)} href="javascript:void(0)">
                            <p className={`dropdown-text ${this.props?.className?this.props?.className:""}`}>
                                {item[this.props.labelParam]}
                                {
                                    (isEmptyVariable(this.props.secondLabelParam) || isEmptyVariable(item[this.props.secondLabelParam]))
                                    ?""
                                    :" "+item[this.props.secondLabelParam]
                                }
                            </p>
                        </Dropdown.Item>
                    })
                }
                {
                    isEmptyArray(this.props.dropdownArr) &&
                    <Dropdown.Item href="javascript:void(0)">
                        <p style={{textAlign:"center"}} className="dropdown-text">No Records</p>
                    </Dropdown.Item>
                }
                </Dropdown.Menu>
            </Dropdown>
            {/* Clear/Eraser icon only when selected */}
            {
                !this.props.disabled && isSelected && this.props.clearSelectedValue &&
                <span 
                    className="material-symbols-outlined eraser-icon" 
                    style={{position:'absolute',right:'10px',top:'50%',transform:'translateY(-50%)',cursor:'pointer',fontSize:'20px',color:'#888'}} 
                    onClick={() => this.props.clearSelectedValue()}
                >ink_eraser</span>
            }
            </div>
        )
    }
}

export default RegularDropDown;